/**
 * Version poller — detects new deploys and auto-reloads the page.
 *
 * Excluded routes: any path containing "/overlay" or "/kiosk" is treated
 * as a broadcast-critical surface and will NEVER be reloaded automatically.
 */

const POLL_INTERVAL = 60_000 // 60 seconds
const EXCLUDED_PATTERNS = ['/overlay', '/kiosk']

let knownVersion = null
let timer = null

function isExcludedRoute() {
  const path = window.location.pathname.toLowerCase()
  return EXCLUDED_PATTERNS.some((p) => path.includes(p))
}

async function fetchVersion() {
  try {
    // Cache-bust to avoid getting a stale CDN / browser-cache response
    const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' })
    if (!res.ok) return null
    const data = await res.json()
    return data.version ?? null
  } catch {
    // Server may be restarting during a deploy — swallow and retry next tick
    return null
  }
}

async function check() {
  const version = await fetchVersion()
  if (!version) return // fetch failed, skip this cycle

  if (knownVersion === null) {
    // First successful fetch — just record what we're running
    knownVersion = version
    return
  }

  if (version !== knownVersion) {
    if (isExcludedRoute()) {
      // New version detected but we're on a broadcast surface — do nothing.
      // We intentionally do NOT update knownVersion here so the check fires
      // again on the next cycle in case the user navigates away.
      return
    }
    // New version on a safe route — reload to pick up the new code
    window.location.reload()
  }
}

/**
 * Start polling. Safe to call multiple times — subsequent calls are no-ops.
 */
export function startVersionPoller() {
  if (timer) return
  // Initial check shortly after mount (give the app a moment to settle)
  setTimeout(check, 5_000)
  timer = setInterval(check, POLL_INTERVAL)
}

/**
 * Stop polling (useful for tests or manual control).
 */
export function stopVersionPoller() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}
